window.theme = window.theme || {};

theme.Collection = (function() {
  var settings = {
    mediaQueryMediumUp: '(min-width: ' + theme.breakpoints.medium + 'px)'
  };

  var selectors = {
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
    selectInput: '[data-select-input]'
  };

  function Collection(container) {


    const target = document.querySelector('.collection-filter-operate');
    const sentinel = document.querySelector('.collection-filter-sentinel');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio < 1 && window.innerWidth < 1023) {
          target.classList.add("fixed");
        } else {
          target.classList.remove("fixed");
        }
      });
    }, {
      root: null,
      threshold: 1.0
    });
    observer.observe(sentinel);



    
    this.filterSelect = container.querySelector(selectors.filterSelection);
    this.sortSelect = container.querySelector(selectors.sortSelection);

    this.selects = document.querySelectorAll(selectors.selectInput);

    if (this.sortSelect) {
      this.defaultSort = this._getDefaultSortValue();
    }

    if (this.selects.length) {
      this.selects.forEach(function(select) {
        select.classList.remove('hidden');
      });
    }

    this.initBreakpoints = this._initBreakpoints.bind(this);

    this.mql = window.matchMedia(settings.mediaQueryMediumUp);
    this.mql.addListener(this.initBreakpoints);

    if (this.filterSelect) {
      this.filterSelect.addEventListener(
        'change',
        this._onFilterChange.bind(this)
      );
    }

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', this._onSortChange.bind(this));
    }

    theme.Helpers.promiseStylesheet().then(
      function() {
        this._initBreakpoints();
      }.bind(this)
    );
    this._initParams();


    var formsArr = container.querySelectorAll('[action="/cart/add"]');
    if(formsArr.length) {
      formsArr.forEach(function(form,index) {
        theme.AddItemToCart(form);

      });
    }
    theme.ProductItemSwatches();

    var sidebar_menu_items = container.querySelectorAll('.panel-heading.collapse');
    if(sidebar_menu_items.length) {
      sidebar_menu_items.forEach(function (item,index) {
        item.addEventListener('click',function (e) {
          e.preventDefault();

          var self = this;
          var panelId = item.getAttribute('data-collapse-panel');
          var itemPanel = document.querySelector('#'+panelId);


          var current_active_block = container.querySelector('.panel-heading.collapse.active');
          if(current_active_block)  {
            var current_block_id = current_active_block.getAttribute('data-collapse-panel');

            if(current_block_id != panelId) {
              current_active_block.dispatchEvent(new Event('click', { bubbles: true }));
            }
          }


          if (!itemPanel.classList.contains('active')) {

            self.classList.add('active');
            itemPanel.classList.add('active');
            itemPanel.style.height = 'auto';

            var height = itemPanel.clientHeight + 'px';

            itemPanel.style.height = '0px';

            setTimeout(function () {
              itemPanel.style.height = height;
            }, 0);

          } else {

            itemPanel.style.height = '0px';

            itemPanel.addEventListener('transitionend', function () {
              itemPanel.classList.remove('active');
              self.classList.remove('active');
            }, {
              once: true
            });

          }

        });
      });
    }

    var filter_titles = container.querySelectorAll('.category-filters-section-title');
    if(filter_titles.length) {
      filter_titles.forEach(function(item,index) {



        var self = item;
        var parentArea = self.closest('.category-filters-area-section');
        var filtersBlock = parentArea.querySelector('.category-filters-area-list');

        if (filtersBlock.classList.contains('active')) {
          filtersBlock.style.height = 'auto';
          var height = filtersBlock.clientHeight + 'px';
          filtersBlock.style.height = height;

        } else {
          filtersBlock.style.height = '0px';
        }


        item.addEventListener('click', function(e) {
          e.preventDefault();

          var self = this;
          var parentArea = self.closest('.category-filters-area-section');
          var filtersBlock = parentArea.querySelector('.category-filters-area-list');

          if (!filtersBlock.classList.contains('active')) {

            self.classList.add('active');
            filtersBlock.classList.add('active');
            filtersBlock.style.height = 'auto';

            var height = filtersBlock.clientHeight + 'px';

            filtersBlock.style.height = '0px';

            setTimeout(function () {
              filtersBlock.style.height = height;
            }, 0);

          } else {
            filtersBlock.style.height = '0px';
            self.classList.remove('active');
            filtersBlock.classList.remove('active');

          }
        });
      });
    }

    var show_more_options = container.querySelectorAll('.show_more_options');
    if(show_more_options.length) {

      container.querySelectorAll('.advanced-filters').forEach(function(filter,index) {
        var children_length = filter.querySelectorAll('li').length;
        if(children_length > 5) {

          var heigth_limit = 0;
          for(var i=0; i < filter.querySelectorAll('li').length; i++) {
            var item = filter.querySelectorAll('li')[i];
            heigth_limit = heigth_limit + item.offsetHeight;
            if(i == 4) {
              break;
            }
          }

          var show_more_option = filter.nextElementSibling;
          if(show_more_option) {
            filter.setAttribute('data-heigth_limit', heigth_limit);
            filter.style.maxHeight = heigth_limit+'px';
            show_more_option.style.display = 'inline-block';
          }
        }
      });

      show_more_options.forEach(function (btn,index) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();

          var filters_list = this.previousElementSibling;
          var heigth_limit = filters_list.getAttribute('data-heigth_limit');
          var default_text = this.getAttribute('data-default-text');

          if(this.classList.contains("openedFilter")) {
            filters_list.style.maxHeight  = heigth_limit+'px';
            this.classList.remove('openedFilter');
            this.innerHTML = default_text;
          } else {

            var filterBlockLength = 0;
            for(var i=0; i < filters_list.querySelectorAll('li').length; i++) {
              var item = filters_list.querySelectorAll('li')[i];
              filterBlockLength = filterBlockLength + item.offsetHeight;
            }
            filters_list.style.maxHeight = filterBlockLength+'px';
            this.classList.add('openedFilter');
            this.innerHTML = theme.strings.show_less;

          }
        });
      });
    };


    var change_layout_btns = container.querySelectorAll('[data-action="change-layout"]');
    if(change_layout_btns.length) {
      change_layout_btns.forEach(function(item,index) {
        item.addEventListener('click', function(e) {
          e.preventDefault();
          var this_btn = this;

          if (this_btn.classList.contains('is-selected')) {
            return;
          }

          var button_parent = this_btn.closest('.filters-toolbar');

          var newLayoutMode = this_btn.getAttribute('data-layout-mode');

          // We save the new attribute so that we can select the appropriate mode without causing reflow
          fetch(window.routes.cartUrl + '/update.js', {
            body: JSON.stringify({
              attributes: {
                'collection_layout': newLayoutMode
              }
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          });

          button_parent.querySelector('.collection__layout-button.is-selected').classList.remove('is-selected');
          this_btn.classList.add('is-selected');
          var collectionWrappers = document.querySelectorAll('.Collection-wrapper');
          if(collectionWrappers.length) {
            collectionWrappers.forEach(function (collectionWrapper,index) {
              collectionWrapper.querySelectorAll('.product-item-block').forEach(function (productBlock,index) {

                if (newLayoutMode === 'grid') {
                  productBlock.classList.remove('view-mode-list');
                  productBlock.classList.add('view-mode-grid');
                } else {
                  productBlock.classList.add('view-mode-list');
                  productBlock.classList.remove('view-mode-grid');
                }
              });
            });
          }
        });
      });
    }


    var pagination_mode = container.getAttribute('data-pagination_mode');
    if(pagination_mode != 'standart') {
      var endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: pagination_mode,
        offset: 500
      });
    }

    var open_sidebar_btn  = container.querySelector('.open_mobile_sidebar');
    var close_sidebar_btn = container.querySelector('.close-collection-sidebar');
    var apply_button = container.querySelector('.apply-button');
    if(open_sidebar_btn) {
      open_sidebar_btn.addEventListener('click', function(e) {
        e.preventDefault();
        var sidebarEl =  container.querySelector('.collection-sidebar');
        if(sidebarEl) {
          sidebarEl.classList.add('show');
          document.querySelector('body').classList.add('show_overlay');
        }
      });
    }
    if(close_sidebar_btn) {
      close_sidebar_btn.addEventListener('click', function(e) {
        e.preventDefault();
        var sidebarEl =  container.querySelector('.collection-sidebar');
        if(sidebarEl) {
          sidebarEl.classList.remove('show');
          document.querySelector('body').classList.remove('show_overlay');
        }
      });
    }

    if(apply_button){
      apply_button.addEventListener('click', function(e) {
        e.preventDefault();
        var FitersFormEl = container.querySelector('.filter-form');
        if(FitersFormEl) {
          const formData = new FormData(FitersFormEl);

          const searchParams = new URLSearchParams(formData).toString();
          var pathname  = window.location.pathname;

          if(FitersFormEl.dataset.hash){
            window.location.href = pathname + "?" + searchParams+"#"+FitersFormEl.dataset.hash; 
          }else{
           window.location.href = pathname + "?" + searchParams;
          }
        } else {

          var href = this.getAttribute('href');
          var pathname  = window.location.pathname;
          var search_url_size = window.location.search.length;
          if(search_url_size) {
            window.location.href = href + window.location.search + "#collection-section";
          } else {
            window.location.href = href + "#collection-section" ;
          }
        }
      });
    }


    var prices_checkboxs = container.querySelectorAll("input[name='cust-price-range']");
    var price_gte = container.querySelector("#price_gte");
    var price_lte = container.querySelector("#price_lte");
    var check_filter_value_btns = container.querySelectorAll('.advanced-filter a');
    if(check_filter_value_btns.length) {
      check_filter_value_btns.forEach( (item,index) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          var parentFilterNode = item.closest('.advanced-filter');
          var filterInput = parentFilterNode.querySelector('[type="checkbox"]');
          if(filterInput) {
            if(filterInput.checked) {
              filterInput.checked = false;
            } else {
              filterInput.checked = true;
            }
          }

          
          if(item.classList.contains("cust-price-range")){
            price_gte.removeAttribute("value")
            price_lte.removeAttribute("value")
            if (filterInput.checked) {
              prices_checkboxs.forEach(cb => {
                if (cb !== filterInput) cb.checked = false;
              });
      
              const vals = filterInput.value.split('-');
              if(vals[0]){
                price_gte.value = vals[0]
              }
              if(vals[1]){
                price_lte.value = vals[1]
              }
            }
          }

          if(window.innerWidth > 1023){
            var FitersFormEl = item.closest('form');
            if(FitersFormEl) {
              const formData = new FormData(FitersFormEl);
  
              const searchParams = new URLSearchParams(formData).toString();
              var pathname  = window.location.pathname;
  
              window.location.href = pathname + "?" + searchParams;
            } else {
  
              var href = item.getAttribute('href');
              var pathname  = window.location.pathname;
              var search_url_size = window.location.search.length;
              if(search_url_size) {
                window.location.href = href + window.location.search + "#collection-section";
              } else {
                window.location.href = href + "#collection-section";
              }
            }
          }
        });
      });
    }
      
    var group__price_rangeBlocks = container.querySelectorAll('.filter-group-display__price-range-input');
    if(group__price_rangeBlocks.length) {
      document.addEventListener('change', function(e){
        var el = e.target;

        if(el.classList.contains('filter-group-display__price-range-input')) {
          var FitersFormEl = el.closest('form');
          if(FitersFormEl) {
            const formData = new FormData(FitersFormEl);

            const searchParams = new URLSearchParams(formData).toString();
            var pathname  = window.location.pathname;
            window.location.href = pathname + "?" + searchParams;
          }

        }
      });
    }
    var price_range_inputs =  container.querySelectorAll('.price_range');
    if(price_range_inputs.length) {
      document.addEventListener('change', function(e){
        var el = e.target;

        if(el.classList.contains('price_range')) {
          var FitersFormEl = el.closest('form');
          if(FitersFormEl) {

            var prices_arr = [];
            var price_range_inputs = FitersFormEl.querySelectorAll('.filter-group-display__price-range-input');
            var price_range_container = el.closest('.price_range_container');
            if(price_range_container) {
              price_range_container.querySelectorAll('.price_range').forEach(function(item,index) {
                var input_val = item.value * 1;
                prices_arr.push(input_val);
              });
              if(price_range_inputs.length) {
                var min = Math.min.apply(null, prices_arr),
                    max = Math.max.apply(null, prices_arr);
                price_range_inputs[0].value = min;
                price_range_inputs[1].value = max;
              }
            }

            const formData = new FormData(FitersFormEl);
            const searchParams = new URLSearchParams(formData).toString();
            var pathname  = window.location.pathname;
            window.location.href = pathname + "?" + searchParams;
          }

        }
      });
    }

    function alignProductInfo(){
      document.querySelector('.CollectionGrid').style.setProperty('--product-title-height', 'auto');
      var titleHeight = 0;
      document.querySelectorAll('.product-card').forEach(function(element){
        element.querySelectorAll('.product-card__link-title').forEach(function(infoElement){
          if(infoElement.clientHeight > titleHeight) titleHeight = infoElement.clientHeight;
        });
      });

      document.querySelector('.CollectionGrid').style.setProperty('--product-title-height', titleHeight + 'px');
    }
    alignProductInfo();
    window.addEventListener('resize', function(){ setTimeout(function(){ alignProductInfo(); }, 500); });

    if(document.querySelector('.collection-search')){
      var searchElement = document.querySelector('.collection-search');
      var searchInput = searchElement.querySelector('.search-field');
      searchInput.addEventListener('focus', function(evt){
        document.querySelector('.search-box-dropdown').style.display = 'block';
        searchInput.classList.add('dropdown-enabled');
        document.querySelector('.search-box').classList.add('focus-active');
      });
      document.addEventListener('mouseup', function(e) {
        var container = document.querySelector('.search-box');
        if (!container.contains(e.target)) {
          if(window.innerWidth > 749){
            searchInput.value = '';
            document.querySelector('.search-box-dropdown').classList.add('show-all');
            document.querySelector('.search-box-dropdown').style.display = 'none';
            searchElement.querySelector('.search-close').style.display = "none";
            searchInput.classList.remove('dropdown-enabled');
          }
        }
      });

      searchElement.querySelector('.search-close').addEventListener('click', function(evt){
        searchInput.value = '';
        if(window.innerWidth > 749){
          document.querySelector('.search-box-dropdown').classList.add('show-all');
        }
        else{
          document.querySelector('.search-box').classList.remove('focus-active');
          searchElement.querySelector('.search-box-dropdown').style.display = "none";
          searchInput.classList.remove('dropdown-enabled');
        }
      });
      searchInput.addEventListener('input', function(evt){
        var inputVal = evt.target.value.toLowerCase();
        searchElement.querySelector('.search-close').style.display = "block";
        document.querySelector('.search-box-dropdown').classList.remove('show-all');
        document.querySelectorAll('.search-box-dropdown .search-item').forEach(function(elem){
          var itemVal = elem.innerText.toLowerCase();
          if(itemVal.search(inputVal) == 0){
            elem.style.display = 'block';
          }
          else{ elem.style.display = 'none'; }
        });
      });
    }

    if(document.querySelectorAll('.accessories-tab-title').length > 0){
      document.querySelectorAll('.accessories-tab-title').forEach(function(tabTitle){
        tabTitle.onclick = function(evt){
          var tabHandle = evt.target.getAttribute('data-tab-title');
          document.querySelectorAll('.accessories-tab-title').forEach(function(tabTitleTemp){
            tabTitleTemp.classList.remove('tab-active');
          });
          evt.target.classList.add('tab-active');
          document.querySelectorAll('.accessories-tab-content').forEach(function(tabContentTemp){
            tabContentTemp.classList.remove('tab-content-active');
          });
          document.querySelector('.accessories-tab-content[data-tab-title='+tabHandle+']').classList.add('tab-content-active');
        }
      });
    }
  }

  Collection.prototype = Object.assign({}, Collection.prototype, {
    _initBreakpoints: function() {
      if (this.mql.matches) {
        slate.utils.resizeSelects(this.selects);
      }
    },

    _initParams: function() {
      this.queryParams = {};
      if (location.search.length) {
        var aKeyValue;
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            this.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    _onSortChange: function() {
      this.queryParams.sort_by = this._getSortValue();

      if (this.queryParams.page) {
        delete this.queryParams.page;
      }

      window.location.search = decodeURIComponent(
        new URLSearchParams(Object.entries(this.queryParams)).toString()
      );
    },

    _onFilterChange: function() {
      document.location.href = this._getFilterValue();
    },

    _getFilterValue: function() {
      return this.filterSelect.value;
    },

    _getSortValue: function() {
      return this.sortSelect.value || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.sortSelect.dataset.defaultSortby;
    },

    onUnload: function() {

      function clearLayoutSettings() {
        var headers = new Headers({ 'Content-Type': 'application/json' });
        var request = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ attributes: { 'collection_layout': '' } })
        };
        fetch('/cart/update.js', request)
        .then(function(response) {
        });
      }
      clearLayoutSettings();

      if (this.filterSelect) {
        this.filterSelect.removeEventListener('change', this._onFilterChange);
      }

      if (this.sortSelect) {
        this.sortSelect.removeEventListener('change', this._onSortChange);
      }

      this.mql.removeListener(this.initBreakpoints);



    }
  });

  return Collection;
})();


document.addEventListener('DOMContentLoaded', function() {
  var sections = new theme.Sections();
  sections.register('collection-template', theme.Collection);
});